// src/styles/theme.js (Beispielpfad)

export const theme = {
  colors: {
    primary: "#3366FF", // Blau (Basis)
    primaryHover: "#254EDB", // Dunkleres Blau
    primaryDark: "#1A3FAD", // Noch dunkleres Blau für Text/Hover
    secondary: "#6E56CF", // Lila
    success: "#16A34A", // Grün
    successBackground: "#F0FDF4",
    successBorder: "#A7F3D0",
    successText: "#14532D",
    danger: "#DC2626", // Rot
    dangerBackground: "#FEF2F2",
    dangerBorder: "#FECACA",
    dangerText: "#991B1B",
    warning: "#F59E0B", // Orange/Gelb
    warningHover: "#D97706",
    warningDark: "#B45309", // Dunkleres Orange für Text
    warningBackground: "#FFFBEB", // Heller Gelb-Hintergrund
    warningBorder: "#FEF3C7", // Heller Gelb-Rand
    warningText: "#92400E", // Dunkler Orange/Braun-Text
    info: "#0EA5E9", // Hellblau
    infoHover: "#0284C7",
    infoDark: "#0369A1", // Dunkleres Hellblau für Text
    infoBackground: "#EFF6FF", // Heller Blau-Hintergrund
    infoBorder: "#DBEAFE", // Heller Blau-Rand
    infoText: "#1E40AF", // Dunkler Blau-Text

    text: "#333333", // Dunkelgrau (Standardtext)
    textLight: "#666666", // Mittelgrau
    textInverted: "#FFFFFF", // Weiß

    heading: "#111111", // Fast Schwarz für Überschriften

    background: "#FFFFFF", // Weißer Hintergrund
    backgroundAlt: "#F8F9FA", // Sehr helles Grau (fast weiß)
    surface: "#FFFFFF", // Oberfläche für Karten etc.

    border: "#E5E7EB", // Hellgrauer Rand
    borderLight: "#F3F4F6", // Sehr heller Rand
    borderDark: "#D1D5DB", // Dunklerer Rand

    disabled: "#D1D5DB", // Deaktiviertes Grau
    disabledText: "#9CA3AF", // Text auf deaktiviertem Grau

    input: "#FFFFFF",
    inputBorder: "#E5E7EB",
    inputFocus: "#3366FF", // Primärfarbe für Fokus

    scrollTrack: "#F1F1F1",
    scrollThumb: "#C1C1C1",
    scrollThumbHover: "#A1A1A1",
  },

  spacing: {
    xs: "0.25rem", // 4px
    sm: "0.5rem", // 8px
    md: "1rem", // 16px
    lg: "1.5rem", // 24px
    xl: "2rem", // 32px
    xxl: "3rem", // 48px
  },

  borderRadius: {
    sm: "0.25rem", // 4px
    md: "0.375rem", // 6px
    lg: "0.5rem", // 8px
    xl: "0.75rem", // 12px
    full: "9999px",
  },

  // Korrekter Name: boxShadow
  boxShadow: {
    xs: "0 1px 2px 0 rgba(0, 0, 0, 0.03)", // Extra klein hinzugefügt
    sm: "0 1px 3px 0 rgba(0, 0, 0, 0.07), 0 1px 2px 0 rgba(0, 0, 0, 0.04)", // Leicht angepasst
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  },

  breakpoints: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    xxl: "1536px",
  },

  // NEU: fonts
  fonts: {
    sans: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    serif: '"Merriweather", Georgia, Cambria, "Times New Roman", Times, serif',
    mono: '"Fira Code", SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  },

  // NEU: transitions
  transitions: {
    fast: "150ms ease-in-out", // Angepasst für Konsistenz
    default: "250ms ease-in-out", // 'normal' umbenannt zu 'default'
    slow: "350ms ease-in-out",
  },
};
